import React from 'react'
import { motion } from 'framer-motion'
import { Wifi, WifiOff, Smartphone } from 'lucide-react'

const OfflineBanner = ({ isOffline, isHotspotMode, getHotspotInstructions }) => {
  if (!isOffline) return null

  const instructions = getHotspotInstructions()

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-500 to-orange-500 text-white p-4 shadow-lg"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <WifiOff className="w-5 h-5" />
          <div>
            <h3 className="font-semibold">You're Offline</h3>
            <p className="text-sm opacity-90">
              {isHotspotMode 
                ? 'Connected to NodeMCU hotspot' 
                : 'No internet connection'
              }
            </p>
          </div>
        </div>

        {!isHotspotMode && (
          <div className="flex items-center space-x-4">
            <div className="text-sm">
              <div className="flex items-center space-x-2">
                <Smartphone className="w-4 h-4" />
                <span>Connect to: <strong>{instructions.ssid}</strong></span>
              </div>
              <div className="text-xs opacity-80">
                IP: <strong>{instructions.ip}</strong>
              </div>
            </div>
            <button
              onClick={() => window.open(instructions.url, '_blank')}
              className="bg-white text-red-500 px-3 py-1 rounded text-sm font-medium hover:bg-gray-100 transition-colors"
            >
              Open NodeMCU
            </button>
          </div>
        )}
      </div>
    </motion.div>
  )
}

export default OfflineBanner
